import axios from 'axios';

import querystring from 'querystring';

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async retrieveTririgaProjects(context, query) {
      try {
        const config = { withCredentials: true };
        const projects = await axios.get(`/tririga/projects?${querystring.stringify(query)}`, config);
        return projects.data;
      } catch (error) {
        throw error;
      }
    },
  },
};
